var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('md-empty-state',{attrs:{"md-label":"Loading 3D model","md-description":"Hold on, the configurator is being loaded"}},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }